import React, { useRef, useState } from 'react';

const DebugButton = props => {
  const longPressTimer = useRef();
  const [isLongPress, setIsLongPress] = useState(false);
  const [clickCount, setClickCount] = useState(0);

  const onTitlePointerDown = () => {
    longPressTimer.current = setTimeout(() => {
      setIsLongPress(true);
    }, 1000);
  };

  const onTitlePointerUp = () => {
    clearTimeout(longPressTimer.current);
  };

  const onTitleClick = () => {
    if (isLongPress) {
      setClickCount(prevState => {
        return prevState + 1;
      });
      if (clickCount >= 3) {
        props.toggle();
        setIsLongPress(false);
        setClickCount(0);
      }
    }
  };

  return (
    <div onPointerDown={onTitlePointerDown} onPointerUp={onTitlePointerUp} onClick={onTitleClick}>
      {props.children}
    </div>
  );
};

export default DebugButton;
